export type GetProjectsResponse = {
  /**
   * The results of this get_projects response body.
   */
  pjtList: Pjt[];
  pjtIdList: string[];
  pjtNameList: string[];
};
export type Pjt = {
  rowNo: number;
  pjtId: string;
  pjtName: string;
  wkFlwStsName: string;
  pjtLnchType: string;
  pjtRgstrDate: string;
  pjtStartDate: string;
  pjtEndDate: string;
  stgDplymntDate: string;
  prdDplymntDate: string;
  dipByRgn: string;
  cpntId: string;
  pjtDesc: string;
  pjtOwner: string;
};
